interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div 
        className="absolute inset-0 bg-hoverBackground backdrop-blur-sm" 
        onClick={onClose} 
      />
      <div className="relative w-full max-w-lg rounded-xl bg-[var(--primaryBackground)] border border-primaryBorder shadow-2xl">
        <div className="px-6 py-5">
          <div className="flex items-start justify-between mb-6">
            <h3 className="text-xl font-semibold text-[var(--primaryText)]">{title}</h3>
            <button 
              onClick={onClose} 
              aria-label="Close" 
              className="text-2xl leading-none text-[var(--secondaryText)] hover:text-[var(--primaryText)] transition-colors"
            >
              ×
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;